import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../../button";
import { TextArea } from "../../../../common/custom-form/custom-textarea.component";

export class AddQuestionModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      inputValue:""
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show}=this.state;

    return(
      <>

    
        <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="comment-plus" iconSize="14px" customClassName="pdf-button" labelName="Add Questiions"/>

      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
               <h5>New Question</h5> 
               <TextArea label="ENTER NEW QUESTION" inputValue={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>Add Question</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
